import { array } from 'prop-types';
import Header from '../../../shared/Header';
import { useTranslation } from 'react-i18next';
import useIconLibrary from '../../../../hooks/useIconLibrary';
import ContactCard from './ContactCard';

const ContactPersonsBlock = ({ contact_persons }) => {
  const { t } = useTranslation();
  const { MessageIcon } = useIconLibrary();

  return (
    <>
      <Header
        title={t('Contactpersonen')}
        icon={<MessageIcon height="2rem" width="2rem" />}
        variant="page"
      />
      {contact_persons.map((contact_person, index) => (
        <ContactCard key={`contact-person-${index}`} {...contact_person} />
      ))}
    </>
  );
};

ContactPersonsBlock.propTypes = {
  contact_persons: array,
};

ContactPersonsBlock.defaultProps = {
  contact_persons: [],
};

export default ContactPersonsBlock;
